import { API } from "./data";
import { Reveal } from "./Reveal";

export function GallerySection({ gallery, onOpenLightbox }) {
  if (!gallery.length) return null;
  return (
    <section className="section gallery-section" id="gallery">
      <div className="container">
        <Reveal>
          <div className="section-label"><span className="chapter-no">08</span>Gallery</div>
          <div className="section-head"><h2>Conferences, workshops &amp; news.</h2><p>Moments from academic meets, conferences and media features.</p></div>
        </Reveal>
        <div className="gallery-grid">
          {gallery.map((photo, index) => (
            <Reveal key={photo.id} delay={(index % 3) * 0.08}>
              <div className="gallery-item gallery-clickable" role="button" tabIndex={0} data-testid={`gallery-photo-${index}`} onClick={() => onOpenLightbox(index)} onKeyDown={(e) => { if (e.key === "Enter") onOpenLightbox(index); }}>
                {photo.content_type?.startsWith("video/") ? <video playsInline preload="metadata" src={`${API}/gallery/image/${photo.storage_path}`} /> : <img src={`${API}/gallery/image/${photo.storage_path}`} alt={photo.caption} loading="lazy" />}
                {!photo.poster_id && <span className="gallery-caption">{photo.caption}</span>}
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
